import { Checkbox, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import _ from "lodash";

export type CheckboxItem = { label: string; value: string };

export interface CheckboxListItemProps {
    checked: boolean;
    item: CheckboxItem;
    onToggle: (checked: boolean) => void;
}

export const CheckboxListItem = (props: CheckboxListItemProps): JSX.Element => {
    const { checked, item, onToggle } = props;
    const labelId = `checkbox-list-label-${_.camelCase(item.value)}`;

    return (
        <ListItem disablePadding>
            <ListItemButton role={undefined} onClick={() => onToggle(!checked)} dense>
                <ListItemIcon>
                    <Checkbox
                        edge="start"
                        checked={checked}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ "aria-labelledby": labelId }}
                    />
                </ListItemIcon>
                <ListItemText id={labelId} primary={item.label} />
            </ListItemButton>
        </ListItem>
    );
};
